import { isOldVersion } from '@/pages/activity/constants';
import { Activity } from '@/types/activity';
import { request } from '@/utils/request';

/**
 * 活动相关相关api
 */
/**
 * 根据模板创建新活动
 * @param params
 * @param payload
 * @returns
 */
export const _createNew = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/createNew', params, payload);
};
/**
 * 获取活动信息
 * @param params
 * @param payload
 * @returns
 */
export const _getInfo = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/getInfo', params, payload);
};
/**
 * 通过查询活动对应模板里的步骤列表后，并根据步骤信息查询其卡片配置列表
 * @param params
 * @param payload
 * @returns
 */
export const _getProcessCards = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/getProcessCards', params, payload);
};

/**
 * 保存活动设置中的多个卡片配置
 * @param params
 * @param payload
 * @returns
 */
export const _setCards = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/setCards', params, payload);
};
/**
 * 设置活动的状态
 */

export const _setStatus = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/setStatus', params, payload);
};
/**
 * 获取单个产品下的全部活动(原活动)
 * 运营1.0和2.0数据结合
 * @param params
 * @param payload
 * @returns
 */
export const _getList = (params?: any, payload?: Request.IPayload) => {
  // return request('/hermes/activity/getList', params, payload);
  return request('/hermes/activity/getListV2', params, payload);
};
/**
 * 单个活动(原活动)的更新操作
 * @param params
 * @param payload
 * @returns
 */
export const _update = (activity: Activity.IInfo, payload?: Request.IPayload) => {
  if (isOldVersion(activity)) {
    return request(
      '/apollo/smartOperation/handleOnePush/updateById',
      { id: activity.id, typeCls: ['3'], handleKey: 'updateById' },
      payload
    );
  }
  return request('/hermes/activity/update', { id: activity.id }, payload);
};
/**
 * 单个活动（原活动）的删除操作
 * @param params
 * @param payload
 * @returns
 */
export const _delete = (activity: Activity.IInfo, payload?: Request.IPayload) => {
  if (isOldVersion(activity)) {
    return request(
      '/apollo/smartOperation/handleOnePush/goDeleteById',
      { id: activity.id, typeCls: ['3'], handleKey: 'goDeleteById' },
      payload
    );
  }
  return request('/hermes/activity/delete', { id: activity.id }, payload);
};
/**
 * 单个活动（原活动）的手动停止
 * @param params
 * @param payload
 * @returns
 */
export const _stop = (activity: Activity.IInfo, payload?: Request.IPayload) => {
  if (isOldVersion(activity)) {
    return request(
      '/apollo/smartOperation/handleOnePush/stopById',
      { id: activity.id, typeCls: ['3'], handleKey: 'stopById' },
      payload
    );
  }
  return request('/hermes/activity/stop', { id: activity.id }, payload);
};
/**
 * 单个活动（原活动）的放弃更新，即删除其更新副本
 * @param params
 * @param payload
 * @returns
 */
export const _stopUpdate = (activity: Activity.IInfo, payload?: Request.IPayload) => {
  if (isOldVersion(activity)) {
    return request(
      '/apollo/smartOperation/handleOnePush/stopUpdateById',
      { id: activity.id, typeCls: ['3'], handleKey: 'stopUpdateById' },
      payload
    );
  }
  return request('/hermes/activity/stopUpdate', { id: activity.id }, payload);
};
/**
 * 单个活动（副本活动）的删除操作（删除更新），删除副本
 * @param params
 * @param payload
 * @returns
 */
export const _deleteUpdate = (activity: Activity.IInfo, payload?: Request.IPayload) => {
  if (isOldVersion(activity)) {
    return request(
      '/apollo/smartOperation/handleOnePush/deleteUpdateById',
      { id: activity.originVersionId, typeCls: ['3'], handleKey: 'deleteUpdateById' },
      payload
    );
  }
  return request('/hermes/activity/stopUpdate', { id: activity.originVersionId }, payload);
};
/**
 * 单个活动撤回发布，从发布状态更新为编辑中状态
 * @param params
 * @param payload
 * @returns
 */
export const _publishBack = (activity: Activity.IInfo, payload?: Request.IPayload) => {
  if (isOldVersion(activity)) {
    return request(
      '/apollo/smartOperation/handleOnePush/backById',
      { id: activity.id, typeCls: ['3'], handleKey: 'backById' },
      payload
    );
  }
  return request('/hermes/activity/publishBack', { id: activity.id }, payload);
};

/**
 * 复制单个活动
 * @param params
 * @param payload
 * @returns
 */
export const _copy = (activity: Activity.IInfo, payload?: Request.IPayload) => {
  if (isOldVersion(activity)) {
    return request('/apollo/smartOperation/duplicateRecord', { sourceOrderId: activity.id, typeCls: ['3'] }, payload);
  }
  return request('/hermes/activity/copy', { id: activity.id }, payload);
};

/**
 * 修改活动
 */
export const _editActivity = (activity: Activity.IInfo, payload?: Request.IPayload) => {
  return request('/hermes/activity/editActivity', { id: activity.id }, payload);
};

/**
 * 放弃修改副本活动
 */
export const _stopEditActivity = (activity: Activity.IInfo, payload?: Request.IPayload) => {
  return request('/hermes/activity/stopEditActivity', { id: activity.id }, payload);
};

/**
 * 灰度发布-发布内容
 * @param id：活动id
 * @param desc：活动描述
 * @param type：活动类型，3白名单，5测试服
 * @param payload
 * @returns
 */
export const _prePublish = (
  params?: { id: string; desc: string; type: 3 | 5 | null; test: Server.IInfo; roster: string[] },
  payload?: Request.IPayload
) => {
  return request('/hermes/activity/prePublish/publish', params, payload);
};

/**
 * 灰度发布-获取灰度发布记录
 * @param id：活动id
 * @param payload
 * @returns
 */
export const _publishRecord = (params?: { id: string }, payload?: Request.IPayload) => {
  return request('/hermes/activity/prePublish/publishRecord', params, payload);
};

/**
 * 灰度发布-测试确认
 * @param id：活动id
 * @param payload
 * @returns
 */
export const _testConfirm = (
  params?: { id: string; type: PrePublish.ITestConfirmType },
  payload?: Request.IPayload
) => {
  return request('/hermes/activity/prePublish/testConfirm', params, payload);
};

/**
 * 灰度发布-获取测试确认记录
 * @param id：活动id
 * @param payload
 * @returns
 */
export const _testConfirmRecord = (params?: { id: string }, payload?: Request.IPayload) => {
  return request('/hermes/activity/prePublish/testConfirmRecord', params, payload);
};

/**
 * 灰度发布-获取灰度发布记录中的白名单详情
 * @param grayReleaseId：灰度发布时候的id
 * @param payload
 * @returns
 */
export const _prePublishRosterDetails = (params?: { grayReleaseId: string }, payload?: Request.IPayload) => {
  return request('/hermes/activity/prePublish/rosterDetails', params, payload);
};
/**
 * 活动当前活动的历史活动版本列表
 * @param id：原活动id
 * @param payload
 * @returns
 */
export const _historyRecord = (params?: { id: number }, payload?: Request.IPayload) => {
  return request('/hermes/activity/historyRecord', params, payload);
};
/**
 * 活动当前活动的历史活动版本列表
 * @param id：原活动id
 * @param payload
 * @returns
 */
export const _modifyCurrentTime = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/modifyCurrentTime', params, payload);
};
/**
 * 获取业务负责人列表
 * @param productCode
 * @param templateServiceId
 * @returns
 */
export const _getTestBusinessManager = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/prePublish/getTestBusinessManager', params, payload);
};
/**
 * 获取活动列表卡片模式
 * @param productCode
 * @param templateServiceId
 * @returns
 */
export const _getActivityCards = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/getActivityCards', params, payload);
};
//获取修改记录
export const _getModifyInfos = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/getModifyInfos', params, payload);
};
//保存修改记录
export const _saveModifyInfos = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/saveModifyInfos', params, payload);
};
/**
 * 获取全部有数据的服务列表
 * @param params
 * @param payload
 * @returns
 */
export const _getAvailableServiceTypeWithDwUnionDataConfig = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/getAvailableServiceTypeWithDwUnionDataConfig', params, payload);
};

// 选择审核人员
export const _selectReviewer = (params: { id: number; reviewer: Person.IBase }, payload?: Request.IPayload) => {
  return request('/hermes/activity/prePublish/selectReviewer', params, payload);
};

// 查询生效审核人
export const _getReviewer = (params: { id: number }, payload?: Request.IPayload) => {
  return request('/hermes/activity/prePublish/getReviewer', params, payload);
};
// 审核人确认
export const _reviewerCheck = (params: { id: number; check: boolean }, payload?: Request.IPayload) => {
  return request('/hermes/activity/prePublish/reviewerCheck', params, payload);
};

// 获取noah流式计算作业接口

export const _getNoahWork = (params: { id: number }, payload?: Request.IPayload) => {
  return request('/hermes/activity/getNoahWork', params, payload);
};

// 修改非策略信息
export const _modifyCards = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/modifyCards', params, payload);
};

// 保存ab实验类型接口
export const _modifyAbExpType = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/modifyAbExpType', params, payload);
};

// 获取实验场景列表接口
export const _getExpSceneInfoList = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/abasExp/getExpSceneInfoList', params, payload);
};

// 获取实验场景详情接口
export const _getExpSceneInfo = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/abasExp/getExpSceneInfo', params, payload);
};

// 获取父实验列表接口
export const _getFatherExpInfoList = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/abasExp/getFatherExpInfoList', params, payload);
};
// 获取联合实验列表接口
export const _getCorrelationExpInfoList = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/abasExp/getCorrelationExpInfoList', params, payload);
};
// 获取实验详情接口
export const _getExpInfo = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/abasExp/getExpInfo', params, payload);
};

// 计算
export const _calculator = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/abasExp/calculator', params, payload);
};

// 新建实验层
export const _createLayer = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/abasExp/createLayer', params, payload);
};

// 新建场景
export const _createScene = (params?: any, payload?: Request.IPayload) => {
  return request('/abas/expDomain/createScene', params, payload);
};

// 实验占用流量估计
export const _expEstimate = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/abasExp/expEstimate', params, payload);
};

// 实验预估作业查询
export const _queryEstimateJob = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/abasExp/queryEstimateJob', params, payload);
};
// 查询开启ab实验的实验信息
export const _getExpInfoByOpId = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/abasExp/getExpInfoByOpId', params, payload);
};

// 获取实验场景详情接口
export const _getExpSceneInfoSnapshot = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/activity/abasExp/getExpSceneInfoSnapshot', params, payload);
};
